import { getOrderProblemsApi } from '@/core/api/generatedApiClient';
import { rethrowHandledApiError } from '@/core/api/rethrowHandledApiError';
import type {
    GetOrderProblemsResponse,
    OrderProblemDetailsResponse,
    OrderProblemsApiGetOrderProblemsRequest,
} from '@/core/generated/api';

/** Выполняет операции с диагностикой проблемных заказов */
export const orderProblemService = {
    /** Возвращает проблемы заказов */
    async getList(
        query: OrderProblemsApiGetOrderProblemsRequest
    ): Promise<GetOrderProblemsResponse> {
        try {
            const response = await getOrderProblemsApi().getOrderProblems(query);

            return response.data;
        } catch (error: unknown) {
            return rethrowHandledApiError(error);
        }
    },

    /** Возвращает данные проблемы заказа */
    async getDetails(id: string): Promise<OrderProblemDetailsResponse> {
        try {
            const response = await getOrderProblemsApi().getOrderProblemDetails({ id });

            return response.data;
        } catch (error: unknown) {
            return rethrowHandledApiError(error);
        }
    },

    /** Повторяет обработку сохранённых данных */
    async retry(id: string): Promise<OrderProblemDetailsResponse> {
        try {
            const response = await getOrderProblemsApi().retryOrderProblem({ id });

            return response.data;
        } catch (error: unknown) {
            return rethrowHandledApiError(error);
        }
    },

    /** Отмечает проблему операции решённой */
    async resolve(id: string): Promise<OrderProblemDetailsResponse> {
        try {
            const response = await getOrderProblemsApi().resolveOrderProblem({ id });

            return response.data;
        } catch (error: unknown) {
            return rethrowHandledApiError(error);
        }
    },
};
